<template>
	<div>
		<img
			@click="openEditSubPlan"
			class="pointer"
			src="/assets/img/edit.png"
			alt="update tax"
			width="25px"
		/>
		<EditSubscriptionPlanModal
			:id="sub.id"
			:closeModal="closeModal"
			:sub="sub"
			:refetch="refetch"
		/>
	</div>
</template>

<script>
	import EditSubscriptionPlanModal from "../modals/EditSubscriptionPlanModal";

	export default {
		name: "EditSubscriptionPlanButton",
		props: ["sub", 'refetch'],
		methods: {
			openEditSubPlan() {
				$(`#${this.sub.id}`).modal("show");
			},
			closeModal() {
				$(`#${this.sub.id}`).modal("hide");
			},
		},
		components: {
			EditSubscriptionPlanModal,
		},
	};
</script>
